import jsonRpc from './request'
import {ProxyUrlPrefix, ZeroAddrHex} from '../constants'
import { mockTokenList } from './mockData'

export const RPC_Method = {
  getTokenList: 'getTokenList',
  searchToken: 'searchToken',
  getUserWallet: 'getUserWallet',
  getUserOperationByHash: 'getUserOperationByHash',
  getUserOperationList: 'getUserOperationList',
  getZGTokenList: 'getTokenList',
  getDepositList: 'getDepositList',
}

export function requestAllTokenList(url) {
  if (process.env.NODE_ENV === 'development') {
    return mockTokenList
  }
  return jsonRpc(url, RPC_Method.getTokenList, [])
}

export function requestToken(url, fromChain, toChain, address) {
  return jsonRpc(url, RPC_Method.searchToken, [fromChain, toChain, address])
}

/**
 *
 * @param {*} url api url
 * @param {*} address (String) user conflux address (shuttle-in) or external chain address (shuttle-out)
 * @param {*} defi (String) conflux defi address (for shuttleflow frontend, hard code zero address)
 * @param {*} fromChain (String) source chain ("btc" | "cfx"). source chain means the chain this token published on, not the chain user is on
 * @param {*} toChain  (String) target chain ("cfx" | "eth" | "bsc"). target chain means the other chain in this cross-chain pair
 * @param {*} type (String) "in" | "out"
 */
export function requestUserWallet([url,
  address,
  defi = ZeroAddrHex,
  fromChain,
  toChain,
  type,]) {
  if (!fromChain || !toChain) return '';
  return jsonRpc(url, RPC_Method.getUserWallet, [
    address,
    defi,
    fromChain,
    toChain,
    type,
  ])
}

/**
 *
 * @param {*} url
 * @param {*} hash  transaction hash
 * @param {*} type "in"(another chain to conflux) | "out" (conflux to another chain)
 * @param {*} fromChain
 * @param {*} toChain
 * @returns
 */
export function requestUserOperationByHash(
  url,
  hash,
  type,
  fromChain,
  toChain,
) {
  return jsonRpc(url, RPC_Method.getUserOperationByHash, [
    hash,
    type,
    fromChain,
    toChain,
  ])
}

/**
 *
 * @param {*} url
 * @param {*} type "in" | "out"
 * @param {*} address user conflux address
 * @param {*} status ["doing", "finished"]
 * @param {*} fromChain
 * @param {*} toChain
 * @param {*} limit the maximum number of operations to return, <= 100
 * @param {*} defi conflux defi address (for shuttleflow frontend, hard code zero address)
 * @returns
 */
export function requestUserOperationList(
  url,
  type,
  address,
  status,
  fromChain,
  toChain,
  limit = 100,
  defi = ZeroAddrHex,
) {
  return jsonRpc(url, RPC_Method.getUserOperationList, [
    {
      type,
      defi,
      address,
      status,
      from_chain: fromChain,
      to_chain: toChain,
    },
    0,
    limit,
  ])
}

export function requestZGTokenList() {
  return jsonRpc(ProxyUrlPrefix.zg, RPC_Method.getZGTokenList, [])
}

export function requestDepositList(
  url,
  account,
  status,
  offset,
  limit = 100,
) {
  return jsonRpc(url, RPC_Method.getDepositList, [
    {
      account,
      status,
      offset,
      limit,
    }
  ])
}

export function requestVolumeSummary(url) {
  return jsonRpc(url, 'getVolumeSummary', [])
}
